import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

// Components
import { Spin, Modal, Form, Row, Col, Alert, Radio, DatePicker } from 'antd';

// Actions
import { getCsvFile } from '../../data/monitoring/actions';

// Selectors
import { getPreselectedMeterId } from '../../data/app/selector';
import { getValidCloudPlan } from '../../data/meters/selectors';

// Constants
import { MODAL_SIZES } from '../../constants/modal';
import moment from 'moment';
import { strings } from '../../localization';

class PeriodSelectModal extends PureComponent {

    constructor(props){
        super(props);
        this.state = {
            period: 5,
            rate: 2,
            from: moment().subtract(5, 'minutes'),
            to: moment()
        };
    }

    handleSubmit = () => {
        const { form, getCsvFile, meterId } = this.props;

        form.validateFields((err, values) => {
            if (err) {
                return;
            }
            // console.log(values);
            if(values.period === 0){
                // user defined period
                getCsvFile(meterId, values.from.valueOf(), values.to.valueOf(), this.isStandard() ? 2 : values.rate);
            } else {
                const { from ,to } = this.state;
                getCsvFile(meterId, from.valueOf(), to.valueOf(), this.isStandard() ? 2 : values.rate);
            }
        });
    };

    // seconds allowed for one day
    isSecondAllowed = () => {
        const {period} = this.state;
        if(period === 0){
            // user defined period
            const {from,to} = this.state;
            return (to.valueOf - from.valueOf) < 25 * 60 * 60 * 1000; // 25 hours
        }
        return period > -3;
    };

    // minutes allowed for one week
    isMinuteAllowed = () => {
        const {period} = this.state;
        if(period === 0){
            // user defined period
            const {from,to} = this.state;
            return (to.valueOf - from.valueOf) < 8 * 24 * 60 * 60 * 1000; // 8 days
        }
        return period > -5;
    };

    handleAlertClose = () => {
        const { form } = this.props;
        form.setFields({
            hasError: {
                value: undefined
            }
        });
    };

    setPeriod = item => {
        let {from, to} = this.state;
        if(item <= 0){
            switch(item){
                case 0:
                    // user defined
                    break;
                case -1:
                    // today
                    to = moment().endOf('day');
                    from = moment().startOf('day');
                    break;
                case -2:
                    // yesterday
                    to = moment().subtract(1, 'days').endOf('day');
                    from = moment().subtract(1, 'days').startOf('day');
                    break;
                case -3:
                    // this week
                    to = moment().endOf('week');
                    from = moment().startOf('week');
                    break;
                case -4:
                    // last week
                    to = moment().subtract(1, 'weeks').endOf('week');
                    from = moment().subtract(1, 'weeks').startOf('week');
                    break;
                case -5:
                    // this month
                    to = moment().endOf('month');
                    from = moment().startOf('month');
                    break;
                case -6:
                    // last month
                    to = moment().subtract(1, 'months').endOf('month');
                    from = moment().subtract(1, 'months').startOf('month');
                    break;
                case -7:
                    // this year
                    to = moment().endOf('year');
                    from = moment().startOf('year');
                    break;
                case -8:
                    // last year
                    to = moment().subtract(1, 'year').endOf('year');
                    from = moment().subtract(1, 'year').startOf('year');
                    break;
                default:
                    break;
            }
        } else {
            to = moment();
            from = moment().subtract(item, 'minutes');
        }
        this.setState({period: item, from, to});
    };

    isPremium = () => {
        const { cloudPlan } = this.props;
        return cloudPlan === 'P';
    };

    isStandard = () => {
        const { cloudPlan } = this.props;
        return cloudPlan === 'S';
    };

    render() {
        const {
            form,
            isShown,
            isLoading = false,
            msgs,
            onCancel
        } = this.props;

        const {
            period,
            from,
            to,
            rate
        } = this.state;

        // console.log(from.valueOf(), to.valueOf());

        const isPremium = this.isPremium();
        const isStandard = this.isStandard();

        const { getFieldValue, getFieldDecorator } = form;

        const radioStyle = {
            display: 'block',
            height: '30px',
            lineHeight: '30px',
        };

        const secAllowed = this.isSecondAllowed();
        const minAllowed = this.isMinuteAllowed();

        return (
            <Modal
                key="users-modal-change-event"
                visible={isShown}
                confirmLoading={isLoading}
                width={MODAL_SIZES.MEDIUM}
                title={msgs.dashboard.downloadSvg}
                onCancel={onCancel}
                onOk={this.handleSubmit}
                cancelText={msgs.close}
                okText={msgs.download}
            >
                <Spin spinning={isLoading} size="large">
                    <Form>
                        {getFieldValue('hasError') && (
                            <Row>
                                <Col xs={24}>
                                    <Alert
                                        message={getFieldValue('hasError')}
                                        type="error"
                                        showIcon
                                        closable
                                        onClose={this.handleAlertClose}
                                    />
                                </Col>
                            </Row>
                        )}

                        <Row gutter={8}>
                            <Col xs={24}>
                                {
                                    isPremium &&
                                    <Form.Item label={msgs.dashboard.resolution}>
                                        {getFieldDecorator('rate', {
                                            initialValue: rate,
                                            rules: [{ required: true, message: msgs.requiredField }]
                                        })(
                                            <Radio.Group buttonStyle="solid" onChange={item => this.setState({rate: item.target.value})}>
                                                <Radio disabled={!secAllowed} style={radioStyle} value={0}>{msgs.dashboard.onePerSecond}</Radio>
                                                <Radio disabled={!minAllowed} style={radioStyle} value={1}>{msgs.dashboard.onePerMinute}</Radio>
                                                <Radio style={radioStyle} value={15}>{msgs.dashboard.onePer15Minutes}</Radio>
                                                <Radio style={radioStyle} value={2}>{msgs.dashboard.onePerHour}</Radio>
                                            </Radio.Group>
                                        )}
                                    </Form.Item>
                                }
                                <Form.Item label={msgs.dashboard.period}>
                                    {getFieldDecorator('period', {
                                        initialValue: period,
                                        rules: [{ required: true, message: msgs.requiredField }]
                                    })(
                                        <Radio.Group buttonStyle="solid" onChange={item => this.setPeriod(item.target.value)}>
                                            {
                                                isPremium &&
                                                <>
                                                    <Radio style={radioStyle} value={5}>{msgs.training.last5min}</Radio>
                                                    <Radio style={radioStyle} value={10}>{msgs.training.last10min}</Radio>
                                                    <Radio style={radioStyle} value={30}>{msgs.training.last30min}</Radio>
                                                    <Radio style={radioStyle} value={60}>{msgs.training.last1hour}</Radio>
                                                    <Radio style={radioStyle} value={180}>{msgs.training.last3hours}</Radio>
                                                    <Radio style={radioStyle} value={360}>{msgs.training.last6hours}</Radio>
                                                    <Radio style={radioStyle} value={720}>{msgs.training.last12hours}</Radio>
                                                    <Radio style={radioStyle} value={1440}>{msgs.training.last24hours}</Radio>
                                                    <Radio style={radioStyle} value={-1}>{msgs.training.today}</Radio>
                                                    <Radio style={radioStyle} value={-2}>{msgs.training.yesterday}</Radio>
                                                    <Radio style={radioStyle} value={-3}>{msgs.training.thisWeek}</Radio>
                                                    <Radio style={radioStyle} value={-4}>{msgs.training.lastWeek}</Radio>
                                                </>
                                            }
                                            <Radio style={radioStyle} value={-5}>{msgs.training.thisMonth}</Radio>
                                            <Radio style={radioStyle} value={-6}>{msgs.training.lastMonth}</Radio>
                                            <Radio style={radioStyle} value={-7}>{msgs.training.thisYear}</Radio>
                                            <Radio style={radioStyle} value={-8}>{msgs.training.lastYear}</Radio>
                                            {
                                                isPremium &&
                                                <Radio style={radioStyle} value={0}>{msgs.training.otherPeriod}</Radio>
                                            }
                                        </Radio.Group>
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>
                        {
                            period === 0 &&
                            <div>
                                <Row gutter={[1, 1]}>
                                    <Col span={4}>{msgs.training.from}:</Col>
                                    <Col span={20}>
                                        <Form.Item>
                                            {getFieldDecorator('from', {
                                                initialValue: from,
                                                rules: [{ required: true, message: msgs.requiredField }]
                                            })(
                                                <DatePicker showTime />
                                            )}
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row gutter={[1, 1]}>
                                    <Col span={4}>{msgs.training.to}:</Col>
                                    <Col span={20}>
                                        <Form.Item>
                                            {getFieldDecorator('to', {
                                                initialValue: to,
                                                rules: [{ required: true, message: msgs.requiredField }]
                                            })(
                                                <DatePicker showTime />
                                            )}
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </div>
                        }
                    </Form>
                </Spin>
            </Modal>
        );
    }
}

export default connect(
    (state, ownProps) => ({
        ...ownProps,
        meterId: getPreselectedMeterId(state),
        cloudPlan: getValidCloudPlan(state)
    }),
    {
        getCsvFile
    }
)(Form.create()(PeriodSelectModal));
